export default __webpack_public_path__ + "static/media/made-easy-phone-left.f496029d.webp";